import React from 'react';
import { arrayOf, string, shape } from 'prop-types';
import { SizeGuide } from '@thd-olt-component-react/size-guide';
import './attribute-label.scss';

export const AttributeLabel = (props) => {
  const {
    attributeName,
    attributeLabelValue,
    attributeMoreInfo,
    sizeGuideInfo
  } = props;

  const {
    parentId,
    collectionId,
    itemId,
    superSkuSizeAndFitDetail = {},
    itemSizeAndFitDetail = {}
  } = sizeGuideInfo || {};

  const hasSizeGuideAttributeGroups = !!itemSizeAndFitDetail?.attributeGroups?.length;

  const hasSizeGuide = () => {
    return attributeName?.toLowerCase() === 'size' && hasSizeGuideAttributeGroups;
  };

  const productType = itemSizeAndFitDetail?.attributeGroups?.[0]?.productType;
  const superSkuIdOrItemId = hasSizeGuideAttributeGroups ? parentId : itemId;
  const sizeGuideItemId = collectionId || superSkuIdOrItemId;

  return (
    <div className="attribute__label">
      <div className="label">
        {attributeName}:
        {attributeLabelValue && <span className="attribute__name u__bold"> {attributeLabelValue}</span>}
        {/* TODO: ----- SSKU Workwear code below -----
        {attributeMoreInfo && (
              <span className="super-sku__inline-moreinfo">
                {attributeMoreInfo}
              </span>
            )}
        */}
      </div>
      {hasSizeGuide()
        && (
          <div className="size-guide-container">
            <SizeGuide
              itemId={sizeGuideItemId}
              productType={productType}
              isSuperSku={!collectionId}
              isCollection={!!collectionId}
              superSkuSizeAndFitDetail={superSkuSizeAndFitDetail}
              itemSizeAndFitDetail={itemSizeAndFitDetail}
            />
          </div>
        )}
    </div>
  );
};

AttributeLabel.displayName = 'AttributeLabel';

AttributeLabel.propTypes = {
  attributeName: string.isRequired,
  attributeLabelValue: string,
  attributeMoreInfo: shape({}),
  sizeGuideInfo: shape({
    collectionId: string,
    itemSizeAndFitDetail: shape({
      attributeGroups: arrayOf(shape({}))
    }),
    parentId: string,
    productType: string,
    superSkuSizeAndFitDetail: shape({
      attributeGroups: arrayOf(shape({}))
    })
  })
};

AttributeLabel.defaultProps = {
  attributeMoreInfo: {},
  attributeLabelValue: '',
  sizeGuideInfo: {
    collectionId: '',
    isSize: false,
    isTowelSize: false,
    parentId: '',
    productType: '',
    superSkuSizeAndFitDetail: {},
  }
};
